import './style/editableButton.scss';

import React, {MouseEventHandler} from 'react';
import {EditableComponentProps, useEditableComponent} from "./editableComponent";
import classNames from 'classnames';
import {DvrdButton, DvrdButtonProps} from '@dvrd/dvr-controls';

type Props = EditableComponentProps & Omit<DvrdButtonProps, 'label'> & {
    onClick: MouseEventHandler;
}

export default function EditableButton(props: Props) {
    const {textKey, className} = props;
    const [content, onChange, editable] = useEditableComponent(textKey);

    if (editable) return (
        <span contentEditable className={classNames('editable-component editable-button', className)}
              dangerouslySetInnerHTML={{__html: content}} onInput={onChange}/>
    );
    return <DvrdButton label={content} {...props}/>
}